import React from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import LazyLoad, { forceCheck } from 'react-lazyload';
import Banner from '@components/Banner/Index';
import Top from './partials/Top';

import './home.scss';
import './home-global.scss';

const LoadableStatic = loadable(() => import('./partials/Static'), {
    fallback: <div>Loading...</div>
});

const MIRA_BUBBLE_KEY = 'mira_bubble_dismissed';

const HomeComponent = () => {
    const agentId = useSelector(state => state.initState.MIRA_AI_AGENT_ID);
    const profileData = useSelector(state => state.checkout.profileData);
    const [showBubble, setShowBubble] = React.useState(false);

    const guestId = React.useMemo(() => {
        return 'guest_' + Date.now().toString(36) + Math.random().toString(36).substring(2);
    }, []);

    const dynamicVariables = JSON.stringify({
        username: profileData?.first_name || profileData?.name || 'Guest',
        user_id: profileData?.account_id || profileData?.id || guestId
    });

    React.useEffect(() => {
        forceCheck();
    });

    React.useEffect(() => {
        if (typeof window === 'undefined') return;

        const scriptId = 'elevenlabs-convai-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
            script.async = true;
            script.type = 'text/javascript';
            script.onload = () => {
                // Try to hide the "Powered by" branding inside the shadow DOM
                let attempts = 0;
                const interval = setInterval(() => {
                    const el = document.querySelector('elevenlabs-convai');
                    if (el && el.shadowRoot) {
                        if (!el.shadowRoot.querySelector('#hide-branding-style')) {
                            const style = document.createElement('style');
                            style.id = 'hide-branding-style';
                            style.innerHTML = `
                                p:has(a[href*="elevenlabs"]), a[href*="elevenlabs.io"], a[href*="elevenlabs"], [class*="powered-by"], [class*="branding"] { display: none !important; opacity: 0 !important; visibility: hidden !important; }
                            `;
                            el.shadowRoot.appendChild(style);
                        }
                        clearInterval(interval);
                    }
                    if (attempts++ > 40) clearInterval(interval); // Stop after 20s
                }, 500);
            };
            document.body.appendChild(script);
        }

        if (!sessionStorage.getItem(MIRA_BUBBLE_KEY)) {
            const timer = setTimeout(() => setShowBubble(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    React.useEffect(() => {
        if (!showBubble) return;
        const timer = setTimeout(() => handleDismiss(), 12000);
        return () => clearTimeout(timer);
    }, [showBubble]);

    const handleDismiss = () => {
        setShowBubble(false);
        if (typeof window !== 'undefined') {
            sessionStorage.setItem(MIRA_BUBBLE_KEY, '1');
        }
    };

    return (
        <div className="home">
            <Banner />
            <Top />

            <LazyLoad once>
                <LoadableStatic />
            </LazyLoad>

            <div className="elevenlabs-float-widget">
                {showBubble && (
                    <div className="mira-bubble">
                        <button
                            className="mira-bubble__close"
                            onClick={handleDismiss}
                            aria-label="Dismiss"
                        >
                            ×
                        </button>
                        <p className="mira-bubble__text">
                            <strong>Hello! I&apos;m Mira</strong>, your AI voice assistant from Droom.
                            I&apos;m an automobile expert here to help you find the right vehicle.
                            Are you looking to <strong>check price of a car or a bike</strong> today?
                            <br />
                            <em>Try speaking or typing below! 🎙️</em>
                            <br /><br />
                            <br /><br />

                        </p>
                        <div className="mira-bubble__arrow" />
                    </div>
                )}
                <elevenlabs-convai
                    agent-id={agentId}
                    dynamic-variables={dynamicVariables}
                ></elevenlabs-convai>
            </div>
        </div>
    );
};

export default HomeComponent;
